import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/layout.tsx");
